import { Helmet } from 'react-helmet-async';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { NewConditionLinkContent } from './components/NewConditionLinkContent';
import { PageWithLayout } from '@/models/page';
import { Permission } from '@/models/user';

const NewConditionLink: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Regelwerk Neu Anlegen | Starjack Admin</title>
            </Helmet>

            <NewConditionLinkContent />
        </>
    );
};

NewConditionLink.isProtected = true;
NewConditionLink.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
NewConditionLink.permissions = [Permission.CONDITION_LINKS_NAV];

export default NewConditionLink;
